import Vue from 'vue'
import Router from 'vue-router'
import http from '../js/request.js'
import api from '../js/api.js'
import store from '../store/index.js'
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/home'  
    },
    {
      path: '/login',
      name: 'login',
      component:()=> import('@/components/login'),
    },
    {
      path: '/home',
      name: 'home',
      component:()=> import('@/components/tabbar'), //底部tab
    }
    ,{
      path: '/fanDetail',
      name: 'fanDetail',
      component:()=> import('@/components/detail/fanDetail'),//扇子详情
    }
    ,{
      path: '/fanList',
      name: 'fanList',
      component:()=> import('@/components/detail/fanList'),//扇子合集
    }
    ,{
      path: '/collection',
      name: 'collection',
      component:()=> import('@/components/detail/collection'),//展品收藏
    }
    ,{
      path: '/placeOrder',
      name: 'placeOrder',
      component:()=> import('@/components/order/placeOrder'),//提交订单
    }
    ,{
      path: '/toPaid',
      name: 'toPaid',
      component:()=> import('@/components/order/toPaid'),//去支付
    }
    ,{
      path: '/success',
      name: 'success',
      component:()=> import('@/components/order/success'),//已完成
    }
    ,{
      path: '/myOrder',
      name: 'myOrder',
      component:()=> import('@/components/order/myOrder'),//我的订单
    }
   
    ,{
      path: '/set',
      name: 'set',
      component:()=> import('@/components/set/set'),//设置
    }
    ,{
      path: '/personal',
      name: 'personal',
      component:()=> import('@/components/set/personal'),//个人中心
    }
    ,{
      path: '/security',
      name: 'security',
      component:()=> import('@/components/set/security'),//账号与安全
    }
    ,{
      path: '/about',
      name: 'about',
      component:()=> import('@/components/set/about'),//账号与安全
    }
    ,{
      path: '/service',
      name: 'service',
      component:()=> import('@/components/set/service'),//客服
    }
    ,{
      path: '/phone',
      name: 'phone',
      component:()=> import('@/components/set/phone'),//更换手机号
    }
    ,{
      path: '/newphone',
      name: 'newphone',
      component:()=> import('@/components/set/newphone'),//更换手机号
    }
    ,{
      path: '/authentication',
      name: 'authentication',
      component:()=> import('@/components/set/authentication'),//实名认证
    }
    ,{
      path: '/payPassword',
      name: 'payPassword',
      component:()=> import('@/components/set/payPassword'),//支付密码
    }
    ,{
      path: '/acctPassword',
      name: 'acctPassword',
      component:()=> import('@/components/set/acctPassword'),//账号密码
    }
    ,{
      path: '/acctLogout',
      name: 'acctLogout',
      component:()=> import('@/components/set/acctLogout'),//账号密码
    }
    ,{
      path: '/newNickname',
      name: 'newNickname',
      component:()=> import('@/components/set/newNickname'),//修改昵称
    }
    ,{
      path: '/signName',
      name: 'signName',
      component:()=> import('@/components/set/signName'),//修改个性签名
    }
    ,{
      path: '/HelloWorld',
      name: 'HelloWorld',
      component:()=> import('@/components/HelloWorld'),
    }
    ,{
      path: '/pageIframe',
      name: 'pageIframe',
      component:()=> import('@/components/pageIframe'),
    }
    ,{
      path: '/transfer',
      name: 'transfer',
      component:()=> import('@/components/transfer'),
    }
  ],
  scrollBehavior(to, from,savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})


// router.beforeEach((to,from,next)=>{
//   http.get(api.getUserInfo,{}).then(res=>{
//     if(to.name!='login') {
//       let list = store.state.pageData.historyList
//       list.push({name:to.name,query:to.query})
//       store.commit('newPageData', { key: 'historyList', data: list})
//       // 
//       next();
//       http.post(api.trackPv,{}).then(res=>{})
//     }else{
//       router.push({name: 'home'})
//     }
//   }).catch(err=>{
    // if(to.name=='login') {
    //   next();
    // }else{
    //   router.push({name: 'login'})
    // }
//   })
// })


router.beforeEach(async (to, from, next) => {
  console.log("to:"+JSON.stringify(to))
  next();
  /**let flag = true
  await http.get(api.getUserInfo,{}).then(res => {
    flag = true;
  }).catch(error=>{
    flag = false
  });
 
  if(flag) {
    if(to.name=='login') {
      router.push({name: 'home'})
    }else{
      next();
    }
  }else{
    if(to.name=='login') {
      next();
    }else{
      router.push({name: 'login'})
    }
  }*/
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js